export default __webpack_public_path__ + "static/media/illus1.bc97da26.jpg";